/* tslint:disable:max-line-length */
import {Injectable, OnDestroy} from '@angular/core';
import {Activity} from '@docma-mm-core/activity/activity';
import {ActivityService} from '@docma-mm-core/activity/activity.service';
import {Attachment} from '@docma-mm-core/attachment/attachment';
import {AttachmentService} from '@docma-mm-core/attachment/attachment.service';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {BehaviorSubject, firstValueFrom, Subject} from 'rxjs';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {Logger} from '@mydocma/common/src/lib/logger';
import {MmTranslateService} from '../../mm-translate.service';
import {MmProjectLoaderService} from '../../mm-project/mm-project-loader.service';
import {filter, map} from 'rxjs/operators';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';


export enum FaultViewEnum {
  Fault,
  EditFault,
  NewFaultAttachmentFromFile,
  NewFaultAttachmentFromCamera,
  EditAttachment,
  NewActivity,
  EditActivity,
  NewActivityAttachmentFromFile,
  NewActivityAttachmentFromCamera,
  ShowActivityAttachments,
  SelectFaultStructure,
  ConfigFields
}
@Injectable(
// {
//   providedIn: 'root'
// }
)
export class MmFaultViewService implements OnDestroy {

  private toggleViewSubject = new Subject<{view: FaultViewEnum, data: any}>();
  private faultLoadingSubject = new BehaviorSubject<boolean>(false);

  onToggleViewRequested = this.toggleViewSubject.asObservable();
  faultLoading$ = this.faultLoadingSubject.asObservable();

  constructor(
    private readonly logger: Logger,
    private readonly notificationService: NotificationService,
    private readonly translateService: MmTranslateService,
    private readonly activityService: ActivityService,
    private readonly attachmentService: AttachmentService,
    private readonly projectLoaderService: MmProjectLoaderService) {
  }

  ngOnDestroy(): void {
  }

  requestToggleView(view: FaultViewEnum, data?: any) {
    this.toggleViewSubject.next({view, data});
  }

  async activityDelete(activity: Activity, fault: ViewFault, deleteGroup: boolean) {
    try {
      let modifiedOn;
      this.faultLoadingSubject.next(true);
      if (fault.changeState.status !== ChangeStatusEnum.New) {
        modifiedOn = await this.activityService.deleteActivity(activity, fault.project.MyDocmaUid, deleteGroup);

        const userPermission = await firstValueFrom(this.projectLoaderService.projectUserPermissions.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded)).pipe(map(x => x.data)));
        fault.data.ModifiedOn = modifiedOn;
        fault.data.Modifier = userPermission.User;
        fault.loadState.data.ModifiedOn = modifiedOn;
        fault.loadState.data.Modifier = userPermission.User;
      }

      fault.removeActivity(activity);


      this.notificationService.success( await this.translateService.get('MM.dialog.deleteActivity.success').toPromise());
      this.faultLoadingSubject.next(false);
      return true;
    } catch (error) {
      this.logger.error(error, '', 'MmFaultViewService');
      if (error.status === 403 && error.error.includes('locking state')) {
        this.notificationService.error( await this.translateService.get('MM.dialog.deleteActivity.errorGroup').toPromise());
      } else {
        this.notificationService.error( await this.translateService.get('MM.dialog.deleteActivity.error').toPromise());
      }
      this.faultLoadingSubject.next(false);
      return false;
    }
  }


  async deleteAttachment(attachment: Attachment, activity: Activity, fault: ViewFault) {
    try {
      this.faultLoadingSubject.next(true);
      let modifiedOn;

      if (fault.changeState.status === ChangeStatusEnum.New || !attachment.id) {
        await this.attachmentService.deleteUnsyncedAttachment(attachment, fault, activity);
      }
      else {
        modifiedOn = await this.attachmentService.deleteAttachment(attachment, fault, activity);

        const userPermission = await firstValueFrom(this.projectLoaderService.projectUserPermissions.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded)).pipe(map(x => x.data)));
        fault.data.ModifiedOn = modifiedOn;
        fault.data.Modifier = userPermission.User;
        fault.loadState.data.ModifiedOn = modifiedOn;
        fault.loadState.data.Modifier = userPermission.User;
      }

      this.notificationService.success( await this.translateService.get('MM.dialog.deleteAttachment.success').toPromise());
      this.faultLoadingSubject.next(false);
      return {successful: true, modifiedOn};
    } catch (error) {
      this.faultLoadingSubject.next(false);
      this.logger.error(error, '', 'MmFaultViewService');
      this.notificationService.error( await this.translateService.get('MM.dialog.deleteAttachment.error').toPromise());
      return {successful: false};
    }
  }
}
